import { Text } from '@fluentui/react-components';
import React from 'react';
import './Placeholder.css';

interface IPlaceholderProps {
  description: string;
  icon: React.ReactElement;
  iconText: string;
}

export default function Placeholder(props: IPlaceholderProps) {
  return (
    <div className="placeholder-root">
      <div className="icon-wrapper">
        <div className="icon">{props.icon}</div>
        <div className="icon-text">{props.iconText}</div>
      </div>
      <Text className="description">{props.description}</Text>
    </div>
  );
}
